// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBrgNKmc0A-8b5SMfm-eaGRRqcMj88yrLc",
  authDomain: "summer-nucleus-390419.firebaseapp.com",
  projectId: "summer-nucleus-390419",
  storageBucket: "summer-nucleus-390419.firebasestorage.app",
  messagingSenderId: "291227383184",
  appId: "1:291227383184:web:f5dbce2f3c1288b974ef15",
  measurementId: "G-LJH2ZDMJ11"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
